module.exports = __webpack_public_path__ + "media/06.c30cb481.mp3";